import { useMemo } from "react";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { useMembershipsObOrderQuery } from "../../../../../api/queries/useMembershipsObOrderQuery";

export function useMemberships() {
  const { tSettings } = useAppTranslation.Settings();

  const { data, isLoading } = useMembershipsObOrderQuery({
    options: {
      onError: () => {
        uiNotification.error(tSettings("memberships.obOrder.error.fetch"));
      },
    },
  });

  const memberships = useMemo(
    () =>
      data?.map((i) => ({
        id: i.id,
        content: i.name,
      })) || [],
    [data],
  );

  return {
    memberships,
    isMembershipsLoading: isLoading,
  };
}
